var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRoundCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0131 16.0814L7.32065 13.3219C7.17557 13.1732 6.9788 13.0897 6.77362 13.0897C6.56844 13.0897 6.37167 13.1732 6.22659 13.3219C6.08151 13.4706 6 13.6723 6 13.8825C6 13.9867 6.02001 14.0898 6.05889 14.186C6.09777 14.2822 6.15475 14.3696 6.22659 14.4432L9.46999 17.7674C9.7726 18.0775 10.2614 18.0775 10.564 17.7674L18.7734 9.35355C18.9185 9.20485 19 9.00318 19 8.79289C19 8.5826 18.9185 8.38093 18.7734 8.23223C18.6283 8.08354 18.4316 8 18.2264 8C18.0212 8 17.8244 8.08354 17.6793 8.23223L10.0131 16.0814Z",
    fill: "#00ABF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundCheck);
export default __webpack_public_path__ + "static/media/ic_round-check.ad9afedbf123193622c59f3426fdf67c.svg";
export { ForwardRef as ReactComponent };